import React, { useEffect, useState } from 'react';
import './App.css';
import './styles/navbar.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopSection from './sections/TopSection';
import Footer from './sections/Footer';
import Navbar from './components/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { CircleLoader } from 'react-spinners';
import AboutUs from './sections/AboutUs';
import OurGoals from './sections/OurGoals';
import JoinUs from './sections/JoinUs';
import Events from './pages/Events'; // Import the Events page

function App() {
  const aboutUsRef = React.createRef<HTMLDivElement>();
  const joinUsRef = React.createRef<HTMLDivElement>();
  const [scrollPos, setScrollPos] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const toTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const scrollToSection = (loc: string) => {
    let element;
    if (loc === 'about') {
      if (!aboutUsRef || !aboutUsRef.current) return;
      element =
        aboutUsRef.current.getBoundingClientRect().top +
        window.scrollY -
        (window.innerWidth > 700 ? 70 : 0);
    } else if (loc === 'join') {
      if (!joinUsRef || !joinUsRef.current) return;
      element = joinUsRef.current.getBoundingClientRect().top + window.scrollY - (window.innerWidth > 700 ? 70 : 0);
    }

    window.scroll({
      top: element,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    setScrollPos(window.pageYOffset);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.scrollTo({ top: 0 })
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  return (
    <Router>
      <div className="App">
        {loaded ? (
          <>
            <Navbar scrollPos={scrollPos} callback={(loc) => scrollToSection(loc)} />

            {/* Define Routes for Home and Events Page */}
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <TopSection callback={(loc) => scrollToSection(loc)} />
                    <div className="main-sections">
                      <AboutUs refProp={aboutUsRef} />
                      <hr className="section-keyline" />
                      <OurGoals />
                      <hr className="section-keyline" />
                      <JoinUs refProp={joinUsRef}/>
                    </div>
                    <Footer callback={(loc) => scrollToSection(loc)} />
                    <button
                      onClick={toTop}
                      className={`back-to-top ${scrollPos < 10}`}
                    >
                      <FontAwesomeIcon icon={faArrowUp} />
                    </button>
                  </>
                }
              />

              {/* Events Page */}
              <Route path="/events" element={<Events />} />
            </Routes>
          </>
        ) : (
          <div className="full">
            <CircleLoader color="black" />
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
